module.exports = __webpack_public_path__ + "static/img/buildsucesse.2abda6eb.jpg";